import React, { useState } from 'react';
import useNFC from '../hooks/useNFC';
import './NFCWriteView.css';

function NFCWriteView({ gridConfig }) {
  const { available, writing, write, error, clearError } = useNFC();
  const [row, setRow] = useState('');
  const [col, setCol] = useState('');
  const [success, setSuccess] = useState(false);

  const handleWrite = async () => {
    setSuccess(false);
    clearError();

    const rowNum = parseInt(row, 10);
    const colNum = parseInt(col, 10);

    if (isNaN(rowNum) || isNaN(colNum)) {
      return;
    }

    await write(rowNum, colNum);
    if (!error) {
      setSuccess(true);
    }
  };

  if (!available) {
    return (
      <div className="nfc-write-view">
        <p className="nfc-write-view__unavailable">
          NFC is not available on this device. NFC writing requires Chrome on Android.
        </p>
      </div>
    );
  }

  const maxRow = gridConfig ? gridConfig.rows - 1 : 99;
  const maxCol = gridConfig ? gridConfig.cols - 1 : 99;

  return (
    <div className="nfc-write-view">
      <h2 className="nfc-write-view__title">Write NFC Tag</h2>

      <div className="nfc-write-view__form">
        <div className="nfc-write-view__field">
          <label htmlFor="nfc-write-row">Row</label>
          <input
            id="nfc-write-row"
            type="number"
            min="0"
            max={maxRow}
            value={row}
            onChange={(e) => setRow(e.target.value)}
            aria-label="Row number"
          />
        </div>

        <div className="nfc-write-view__field">
          <label htmlFor="nfc-write-col">Column</label>
          <input
            id="nfc-write-col"
            type="number"
            min="0"
            max={maxCol}
            value={col}
            onChange={(e) => setCol(e.target.value)}
            aria-label="Column number"
          />
        </div>

        <button
          className="nfc-write-view__btn"
          onClick={handleWrite}
          disabled={writing || row === '' || col === ''}
        >
          {writing ? 'Writing...' : 'Write to Tag'}
        </button>
      </div>

      {writing && (
        <p className="nfc-write-view__status" role="status">
          Hold your device near an NFC tag to write...
        </p>
      )}

      {success && (
        <p className="nfc-write-view__success" role="status">
          Successfully wrote position to NFC tag!
        </p>
      )}

      {error && (
        <p className="nfc-write-view__error" role="alert">
          {error}
        </p>
      )}
    </div>
  );
}

export default NFCWriteView;
